export default __webpack_public_path__ + "static/media/Barra-Cursos.aad00cab.webp";